<script>

    import { shipmentStore } from '../stores'

</script>

{#if $shipmentStore.problemType}
    <div>
        <div class="title">Tipo de problema</div>
        <div class="subtitle">{ $shipmentStore.problemType }</div>
    </div>
{/if}